<template>
  <div class="inner-box">
      <div class="content-name">
          <h2 class="dp-ib">{{title}}</h2>
          <div class="btn-wrap btn-type1 clearfix">
              <button class="btn-size btn-blue fl_left" @click="goSearch"><span class="btn-icon"><i
                      class="fas fa-pen-alt"></i></span> 조회
              </button>
          </div>
      </div>

      <!-- 검색조건 영역 -->
      <div class="desc-content search-border">
          <div class="item desc-left">
              <div class="desc-item">
                  <div class="tit">
                      <span class="label-tit">방문목적</span>
                  </div>
                  <div class="desc" style="width: 70%">
                      <b-select class="select is-fullwidth" v-model="form.purpose">
                          <option value=''>==전체==</option>
                          <option
                                  v-for="item in purposes"
                                  :key="item.key"
                                  :value="item.key"
                                  v-text="item.value"/>
                      </b-select>
                  </div>
              </div>

              <div class="desc-item">
                  <div class="tit">
                      <span class="label-tit">진행상태</span>
                  </div>
                  <div class="desc" style="width: 70%">
                      <b-select class="select is-fullwidth" v-model="form.visitStatCd">
                          <option value=''>==전체==</option>
                          <option
                                  v-for="item in visitStats"
                                  :key="item.key"
                                  :value="item.key"
                                  v-text="item.value"/>
                      </b-select>
                  </div>
              </div>
              <div class="desc-item">
                  <div class="tit">
                      <span class="label-tit">방문일자</span>
                  </div>
                  <div class="desc">
                      <div class="datepicker w-type-ymd02">
                          <dhx-calendar class="input ddate sDate" v-model="form.searchVDtmFr" />
                      </div>
                      <span class="wave"> ~ </span>
                      <div class="datepicker w-type-ymd02">
                          <dhx-calendar class="input ddate sDate" v-model="form.searchVDtmTo" />
                      </div>
                      <div class="btn-wrap btn-type2 clearfix" style="float:left; padding-left: 5px; padding-top: 2px; margin-bottom: 0px">
                        <button class="btn-size btn-w-gray" @click="setToday()" style="height: 22px; padding: 0 8px; font-size: 12px">
                          오늘
                        </button>
                      </div>
                  </div>
              </div>
          </div>
          <div class="item desc-center">
              <div class="desc-item">
                <div class="tit">
                  <span class="label-tit">방문회사</span>
                </div>
                <div class="desc" style="width: 70%">
                  <b-select class="select is-fullwidth" v-model="form.visitCompCd">
                    <option value=''>==전체==</option>
                    <option value='100010'>일진전기</option>
                    <option value='100002'>일진홀딩스</option>
                    <option value='101301'>일진다이아</option>
                    <option value='222300'>알피니언메디칼</option>
                  </b-select>
                </div>
              </div>
              <search-dept-mg title="방문부서" v-model="form" :options="{ type: '01', deptCd: 'visitDept', deptNm: 'deptNm', authorize: true }" @submit="goSearch" style="width: 100%;" />
              <search-emp-mg title="피방문자" v-model="form" :options="{ type: '01', empNo: 'visitEmp', empNm: 'empNm', dutNm: 'wrtDutNm', deptNm: 'wrtCctrNm' }" @submit="goSearch" style="width: 100%;"/>
          </div>
          <div class="item desc-right">
              <div class="desc-item" style="width: 80%">
                  <div class="tit">
                      <span class="label-tit">신청자명</span>
                  </div>
                  <div class="desc">
                      <input class="input Rt-M tal" type="text" v-model="form.visitorFirstNm" @keypress.enter.prevent="goSearch">
                  </div>
              </div>
              <div class="desc-item" style="width: 80%">
                  <div class="tit">
                      <span class="label-tit">방문자명</span>
                  </div>
                  <div class="desc">
                      <input class="input Rt-M tal" type="text" v-model="form.visitorNm" @keypress.enter.prevent="goSearch">
                  </div>
              </div>
              <div class="desc-item" style="width: 80%">
                  <div class="tit">
                      <span class="label-tit">회사명</span>
                  </div>
                  <div class="desc">
                      <input class="input Rt-M tal" type="text" v-model="form.visitorComp" @keypress.enter.prevent="goSearch">
                  </div>
              </div>
          </div>
      </div>
      <!-- //검색조건 영역 -->

      <!-- 테이블 -->
      <div class="table-area">
          <div class="table-b">
              <div class="table-header">
                  <div class="table-name">
                      <h3 class="ico_table_name">방문차량 목록</h3>
                  </div>
                  <div class="btn-wrap btn-type1 clearfix">
                      <button class="btn-size btn-excel" @click="saveExcel">엑셀 저장</button>
                  </div>
              </div>
              <div class="grid-wrap">
                  <dhx-grid ref="grid" v-model="secuItemList" :config="config" @constructGridSuccessful="constructGridSuccessful"/>
              </div>
          </div>
      </div>
      <!-- //테이블 -->

      <!--팝업-->
      <b-modal :active.sync="showEmpModal" has-modal-card @receive="receiveEmp">
          <emp :param="form.draftNm"></emp>
      </b-modal>
      <!--//팝업 -->
  </div>
</template>

<script>
  import mixin from '@/mixin';
  import mixinSlip from '@/mixin/slip';
  import _ from 'lodash'

  import DhxCalendar from '@/components/DhxCalendar.vue'
  import DhxGrid from '@/components/DhxGrid.vue'
  import Emp from '@/components/Emp.vue';
  import SearchDeptMg from '@/components/SearchDeptMg.vue'
  import SearchEmpMg from '@/components/SearchEmpMg.vue'

  export default {
      name: 'VisitSecuItemMgList',
      mixins: [mixin, mixinSlip],
      components: {Emp, DhxGrid, DhxCalendar, SearchDeptMg, SearchEmpMg},
      data() {
          return {
              config : {
                  columns: [
                      {id: 'no', type: 'cntr', align: 'center', sort: 'na', value: 'No.', width: 35},
                      {id: 'compNm', type: 'ro', align: 'center', sort: 'na', value: '방문회사', width: 120},
                      // {id: 'visitEtcNms', type: 'ro', align: 'center', sort: 'na', value: '기타사항', width: 120},
                      {id: 'visitYmd', type: 'ron', align: 'center', sort: 'na', value: '방문일', width: 200},
                      // {id: 'carNm', type: 'ro', align: 'center', sort: 'na', value: '차량명', width: 100},
                      // {id: 'carNumber', type: 'ro', align: 'center', sort: 'na', value: '차량번호', width: 100},
                      {id: 'visitorNm', type: 'ro', align: 'center', sort: 'na', value: '방문자명', width: 80},
                      {id: 'visitorComp', type: 'ro', align: 'center', sort: 'na', value: '방문자회사', width: 150},
                      // {id: 'carCategoryNm', type: 'ro', align: 'center', sort: 'na', value: '차량구분', width: 100},
                      {id: 'visitorBirth', type: 'ro', align: 'center', sort: 'na', value: '생년월일', width: 100},
                      {id: 'visitorMobile', type: 'ro', align: 'center', sort: 'na', value: '핸드폰번호', width: 120},
                      {id: 'useContents', type: 'ro', align: 'center', sort: 'na', value: '사용목적', width: 120},
                      {id: 'visitorAssetNm', type: 'ro', align: 'center', sort: 'na', value: '자산구분', width: 120},
                      {id: 'takeOfOutNm', type: 'ro', align: 'center', sort: 'na', value: '반입/반출', width: 120},
                      {id: 'visitorCategoryNm', type: 'ro', align: 'center', sort: 'na', value: '구분', width: 120},
                      {id: 'modelNm', type: 'ro', align: 'center', sort: 'na', value: '모델명', width: 120},
                      {id: 'serialNm', type: 'ro', align: 'center', sort: 'na', value: '시리얼번호', width: 120},

                      {id: 'visitEmp', type: 'ro', align: 'center', sort: 'na', value: '피방문자', width: 80},
                      {id: 'visitDept', type: 'ro', align: 'center', sort: 'na', value: '방문부서', width: 150},
                      {id: 'visitNo', type: 'ro', align: 'center', sort: 'na', value: '방문번호', width: 120, hide: true},
                  ],
                  height: 483,
                  enablePaging: true,
                  pagingSize: 12,
                  afterRefreshData(grid, data) {
                      this.$nextTick(() => {
                      })
                  }
              },
              title: '마곡빌딩 보안물품 리스트',
              params: {},
              docTypes: [],
              purposes: [],
              visitStats: [],
              secuItemList: [],
              sortAsc: 'Y',
              checked: 'checked',
              showEmpModal: false,
              visitPlaceCds: '',
              visitPlaceList:[],
              visitEtcCds: '',
              visitEtcList:[],
              form: {
                  visitCompCd: '',
                  docTypeCd: '',
                  purpose: '',
                  visitStatCd: '',
                  searchVDtmFr: this.$moment().format('YYYY-MM-DD'),
                  searchVDtmTo: this.$moment().format('YYYY-MM-DD'),
                  visitDept: '',
                  visitEmp: '',
                  visitorFirstNm: '',
                  visitorComp: '',
                  visitorNm: '',
                  businessAreaCd: 'B1',
              },
          };
      },
      methods: {
          constructGridSuccessful(grid) {
              grid.attachEvent('onHeaderClick', (cId) => {
                  if(this.sortAsc ==='Y') {
                      grid.sortRows(cId, "str", "des")
                      this.sortAsc = 'N'
                  }
                  else {
                      grid.sortRows(cId, "str", "asc");
                      this.sortAsc = 'Y'
                  }
              });
          },
          getPurposeCdCombo() {
              this.$http.get(`/api/code/combo`, { params: { groupCd: "PURPOSE_CD" } })
                  .then(response => {
                      this.purposes = response.data;
                  });
          },
          getVisitStatCdCombo() {
              this.$http.get(`/api/code/combo`, { params: { groupCd: "VISIT_STAT_CD", remark1: "Y", remark2: "Y" } })
                  .then(response => {
                      this.visitStats = response.data;
                  });
          },
          getDocTypeCombo() {
              this.$http.get(`/api/code/combo`, {params: {groupCd: "VISIT_TYPE_CD"}})
                  .then(response => {
                      this.docTypes = response.data;
                  });
          },
          saveExcel() {
              this.downloadExcel(this.$refs.grid);
          },
          goSearch() {
              const param = JSON.parse(JSON.stringify(this.form));

              const stripFields = ['searchVDtmFr', 'searchVDtmTo'];
              _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]));

              if (param.searchVDtmFr > param.searchVDtmTo) {
                  this.$swal({type: 'warning', text: '방문 시작일자와 종료일자 지정이 잘못되었습니다.'});
                  return false
              }

              const searchInfo = {};
              Object.assign(searchInfo, this.form, {title: this.title});
              this.$store.commit('searchCondition', searchInfo);

              this.$store.commit('loading');
              this.$http.post(`/api/visit/secuItemMgList`, param)
                  .then(response => {
                      if (response.data) {
                          let data = response.data
                          //핸드폰 번호 유형으로 변환
                          let regExp =/(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/
                          let myArray
                          for(let i=0; i<data.length; i++){
                              myArray = regExp.exec(data[i].visitorMobile)
                              data[i].visitorMobile = myArray[1] + '-' + myArray[2] + '-' + myArray[3]

                              //기타사항 코드 명칭으로 변환
                              this.visitEtcList = String(data[i].visitEtcCd).split(",")
                              let visitEtcNms = ''
                              for(let i=0; i<this.visitEtcCds.length; i++){
                                for(let j=0; j<this.visitEtcList.length; j++){
                                  if(this.visitEtcCds[i].key == this.visitEtcList[j]){
                                    visitEtcNms += this.visitEtcCds[i].value + ', '
                                  }
                                }
                              }
                              visitEtcNms = visitEtcNms.trim().substr(0,visitEtcNms.length-2)
                              data[i].visitEtcNms = visitEtcNms
                          }

                          this.secuItemList = data;
                      }
                  }).finally(() => {
                  this.$store.commit('finish')
              });
          },
          setToday() {
            this.form.searchVDtmFr = this.$moment().format('YYYY-MM-DD')
            this.form.searchVDtmTo = this.$moment().format('YYYY-MM-DD')
          },
          popEmp(clear) {
              if (clear === true) {
                  this.form.draftUserId = '';
                  this.form.draftNm = '';
                  this.form.draftUserDut = '';
                  this.form.draftUserDept = '';
              }
              this.showEmpModal = true;
          },
          receiveEmp(obj) {
              this.form.draftUserId = obj.empNo;
              this.form.draftNm = obj.empNm;
              this.form.draftUserDut = obj.dutNm;
              this.form.draftUserDept = obj.deptNm;
          },
          initEmp(force) {
              if (force === true) this.form.draftNm = '';
              if (this.form.draftNm === '') {
                  this.form.draftUserId = '';
                  this.form.draftUserDut = '';
                  this.form.draftUserDept = '';
              }
          },
          setCallPageByParam(){
              if (this.$route.query) {
                  for (let member in this.form) {
                      if (this.$route.query[member] !== undefined) {
                          this.form[member] = this.$route.query[member]
                      }
                  }
              }
          },
          getVisitPlaceCdsCombo(compCd, businessAreaCd) {
            this.$http.get(`/api/code/combo`, { params: { compCd: compCd, groupCd: "VISIT_PLACE_CD", remark1: businessAreaCd} })
                .then(response => {
                  this.visitPlaceCds = response.data;
                });
          },
          getVisitEtcCdsCombo(compCd, businessAreaCd) {
            this.$http.get(`/api/code/combo`, { params: { compCd: compCd, groupCd: "VISIT_ETC_CD", remark1: businessAreaCd} })
                .then(response => {
                  this.visitEtcCds = response.data;
                });
          },
      },

      created() {
        //Admin 권한 체크
        if(this.$store.state.loginInfo.authorities[0].roleCd != "ADMIN") {
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '관리자만 접속 가능합니다.'})
                ,100});
          this.$router.push({path: `/ijmt`});
        };
      },

      mounted() {
          if(this.$store.state.searchInfo !== null) {
              if (this.title === this.$store.state.searchInfo.title)
                  Object.assign(this.form, this.$store.state.searchInfo);
              else
                  this.$store.state.searchInfo = ''
          }
          //this.getVisitPlaceCdsCombo()
          this.getVisitEtcCdsCombo()
          this.setCallPageByParam()
          this.getPurposeCdCombo()
          this.getVisitStatCdCombo()
          this.goSearch()
      },
      watch: {
          'form.searchVDtmFr': {
              handler(value) {
                  if(this.toPure(value) > this.toPure(this.form.searchVDtmTo))
                      this.form.searchVDtmTo = value
              }
          },
          'form.searchVDtmTo': {
              handler(value) {
                  if(this.toPure(value) < this.toPure(this.form.searchVDtmFr))
                      this.form.searchVDtmFr = value
              }
          },
      }
  };
</script>

<style scoped>
  .desc-content:after {
      clear: both;
      content: '';
      display: block;
  }

  .btn-wrap {
      margin-bottom: 10px;
  }

  .desc-content {
      border: 2px solid #9db6c9;
      background: #f9fafc;
      margin: 0 0 20px 0;
      border-radius: 4px;
      padding: 15px 2%;
      clear: both;
  }

  .desc-content .item {
      float: left;
  }

  .desc-content .item .desc-item {
      position: relative;
      padding-left: 82px;
      margin-bottom: 8px;
  }

  .desc-content .item.desc-center .desc-item {
      padding-left: 120px;
  }

  .desc-content .item .desc-item:last-child {
      margin-bottom: 0;
      height: 25px;
  }

  .desc-content .item .desc-item .tit {
      position: absolute;
      left: 0;
  }

  .desc-content .item .desc-item .label-tit {
      font-family: 'NotoM';
      color: #222;
      font-size: 15px;
  }

  .desc-content .item.desc-left .desc-item {
      padding-left: 90px;
  }

  .desc-content .item.desc-left .desc-item .desc:after {
      clear: both;
      content: '';
      display: block;
  }

  .desc-content .item.desc-left .desc-item .desc .datepicker {
      float: left;
  }

  .desc-content .item.desc-left .desc-item .desc span.wave {
      float: left;
      padding: 0 6px;
  }

  .desc-content .desc-item .td-s-thumb.search-area:after {
      clear: both;
      content: '';
      display: block;
  }

  .desc-content .desc-item .td-s-thumb.search-area input,
  .desc-content .desc-item .td-s-thumb.search-area .ip-box {
      float: left;
  }

  .desc-content .item.desc-left .desc-item .desc.select select {
      width: 70%;
  }

  .desc-content .item.desc-left {
      width: 40%;
  }

  .desc-content .item.desc-center {
      width: 40%;
      padding-right: 40px;
  }

  .desc-content .item.desc-right {
      width: 20%;
  }

  .desc-content .item .desc-item .select select,
  .desc-content .item .desc-item .input-box input {
      width: 70%;
  }

  .desc-content .item.desc-right .desc-item .select select,
  .desc-content .item.desc-right .desc-item .input-box input {
      width: 100%;
  }

  .search-area input {
      position: relative;
  }

  .search-area .icon {
      position: absolute;
      right: 8px;
      top: 1px;
      z-index: 100;
      cursor: pointer;
      font-size: 16px;
      color: #555;
  }

  .search-border .td-s-thumb {
      position: relative;
      display: inline-block;
      width: 48%;
  }

  .search-border .td-s-thumb.search-area>input,
  .search-border .td-s-thumb.search-area>.ip-box .search-border .td-s-thumb.search-area>button {
      float: left;
  }

  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
      width: 65%;
      margin-left: 6px;
  }

  .remove_text {
      margin-left: 0;
  }

  .contents div.gridbox_material.gridbox .xhdr {
      border-bottom: 1px solid #dfdfdf;
  }

  @media (max-width:1580px) {
      .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
          width: 50%;
      }
  }

  textarea {
      height: 80px;
  }

  .search-form .form-group{margin-bottom:8px}
</style>
